import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive()
export abstract class ControlBase {
  public internalControl: AbstractControl | undefined = undefined;
  @Input() controlName = '';
  @Input() groupName = '';
  @Input() initialValue = '';
  @Input() placeHolder = '';
  @Input() emptyDisplayValue = '';
  @Input() form: UntypedFormGroup = new UntypedFormGroup({});

  public hasInitialValue(): boolean {
    return (this.initialValue ?? '') != '';
  }
}
